<script setup>
const route = useRoute()
const cameraId = route.params.id
const { data: livecamData } = await useFetch('/api/livecam/detail', { query: { id: cameraId, type: 'all' } })
if (!isValidAreaAndPref(route.params.area, route.params.pref) || !livecamData.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
useCustomMeta('point', livecamData.value.name)
const breadCrumbList = getBreadCrumb(route.params.area, route.params.pref, `${livecamData.value.name}のライブカメラ`)
const tenkiLink = await getTenkiLink(livecamData.value.citycode)
</script>

<template>
  <NuxtLayout
    name="custom"
    :bread-crumb-list="breadCrumbList"
  >
    <div class="frame">
      <LivecamContent :livecam-data="livecamData" />
      <LivecamInfo
        :lat="livecamData.lat"
        :lon="livecamData.lon"
        :direction="livecamData.direction"
        :name="livecamData.name"
        :tenki-link="tenkiLink"
      />
      <LivecamAroundList
        :title="livecamData.name"
        :lat="livecamData.lat"
        :lon="livecamData.lon"
      />
    </div>
  </NuxtLayout>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
